/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.NewsEntryForm.title',
    defaultMessage: 'Title',
  },
  validFrom: {
    id: 'app.components.NewsEntryForm.validFrom',
    defaultMessage: 'Visible from',
  },
  validUntil: {
    id: 'app.components.NewsEntryForm.validUntil',
    defaultMessage: 'Visible until',
  },
  attachments: {
    id: 'app.components.NewsEntryForm.attachments',
    defaultMessage: 'Attachments',
  },
  attachmentUpload: {
    id: 'app.components.NewsEntryForm.attachmentUpload',
    defaultMessage: 'Add attachment',
  },
  attachmentUploadFailed: {
    id: 'app.components.NewsEntryForm.attachmentUploadFailed',
    defaultMessage: 'Upload of attachment failed.',
  },
  attachmentUploadSucceeded: {
    id: 'app.components.NewsEntryForm.attachmentUploadSucceeded',
    defaultMessage: 'Attachment uploaded successfully.',
  },
  deleteAttachment: {
    id: 'app.components.NewsEntryForm.deleteAttachment',
    defaultMessage: 'Delete',
  },
  visibility: {
    id: 'app.components.NewsEntryForm.visibility',
    defaultMessage: 'Visibility',
  },
  content: {
    id: 'app.components.NewsEntryForm.content',
    defaultMessage: 'Content',
  },
  shiftLeader: {
    id: 'app.components.NewsEntryForm.shiftLeader',
    defaultMessage: 'Team leader',
  },
  vip: {
    id: 'app.components.NewsEntryForm.vip',
    defaultMessage: 'VIP',
  },
  publisher: {
    id: 'app.components.NewsEntryForm.publisher',
    defaultMessage: 'Publisher',
  },
  administrator: {
    id: 'app.components.NewsEntryForm.administrator',
    defaultMessage: 'Administrator',
  },
  externalImagesNotAllowed: {
    id: 'app.components.NewsEntryForm.externalImagesNotAllowed',
    defaultMessage:
      'External images cannot be embedded. Please attach the respective image to this news entry.',
  },
  save: {
    id: 'app.components.NewsEntryForm.save',
    defaultMessage: 'Save news entry',
  },
});
